module.exports = __webpack_public_path__ + "img/action-continue-btn.f7eadc9e.png";